export const CHANNEL_TABLE_HASHMAP = {
    trafficType: {
        title: 'Traffic Channel',
        key: 'trafficType',
        rowTestKey: 'channelTableName',
        summaryTestKey: 'summaryName',
    },
    adVisits: {
        title: 'Ad Visits',
        key: 'adVisits',
        rowTestKey: 'channelTableAdVisits',
        summaryTestKey: 'summaryAdVisits',
    },
    newAdUsers: {
        title: 'New Ad Users',
        key: 'newAdUsers',
    },
    ads: {
        title: 'Ads',
        key: 'ads',
        rowTestKey: 'channelTableAds',
        summaryTestKey: 'summaryAds',
    },
    visitOfAds: {
        title: 'Ad Visits/Ads',
        key: 'visitOfAds',
        rowTestKey: 'channelTableAdvisitsAds',
        summaryTestKey: 'summaryVisitsAds',
    },
    newAdUsersOfAds: {
        title: 'New Ad Users/Ads',
        key: 'newAdUsersOfAds'
    },
    avgAdCost: {
        title: 'Avg. Ad Cost',
        key: 'avgAdCost',
        rowTestKey: 'channelTableAvgAdCost',
        summaryTestKey: 'summaryAdCost',
    }
};

export const CHANNEL_KEYS = Object.keys(CHANNEL_TABLE_HASHMAP);

export const CHANNEL_CSV_HASHMAP = {
    trafficType: {
        title: 'Traffic Channel',
        key: 'trafficType'
    },
    adVisits: {
        title: 'Ad Visits',
        key: 'adVisits'
    },
    newAdUsers: {
        title: 'New Ad Users',
        key: 'newAdUsers'
    },
    adVisitsRate: {
        title: 'Ad Visits Percentage',
        key: 'adVisitsRate'
    },
    newAdUsersRate: {
        title: 'New Ad Users Percentage',
        key: 'newAdUsersRate'
    },
    ads: {
        title: 'Ads',
        key: 'ads'
    },
    visitOfAds: {
        title: 'Ad Visits/Ads',
        key: 'visitOfAds'
    },
    newAdUsersOfAds: {
        title: 'New Ad Users/Ads',
        key: 'newAdUsersOfAds'
    },
    avgAdCost: {
        title: 'Avg. Ad Cost',
        key: 'avgAdCost'
    }
};

export const KEYWORD_TABLE_HASHMAP = {
    keywordValue: {
        title: 'Search Keywords',
        key: 'keywordValue'
    },
    visits: {
        title: 'Visits',
        key: 'visits'
    },
    newAdUsers: {
        title: 'New Ad Users',
        key: 'newAdUsers'
    },
    newUsers: {
        title: 'New Users',
        key: 'newUsers'
    },
    adVisits: {
      title: 'Ad Visits',
      key: 'adVisits',
    },
};
export const AD_VISIT_KEYWORD_INFO = 'Keywords users searched for prior to an attributable session.';
export const DEFAULT_KEYWORD_DISPLAY_COLUMNS = [
    'keywordValue',
    'adVisits'
];

export const INIT_NEW_AD_USERS_PER_AD_SORT = {
    sortKey: 'newAdUsersOfAds',
    sortType: 'desc'
};

export const INIT_NEW_AD_USERS_SORT = {
    sortKey: 'newAdUsers',
    sortType: 'desc'
};

export const INIT_AD_VISITS_SORT = {
    sortKey: 'adVisits',
    sortType: 'desc'
};
